// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CentralAfricanRepublic from '../_raw/flag/icon_flag_central_african_republic.png';

export default () => <img src={CentralAfricanRepublic} alt="CentralAfricanRepublic" />;
